import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import {
	Collapse,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import IconButton from "@material-ui/core/IconButton";
import boxScoreStyles from "../styles/BoxScore.styles";
import teamComparisonStyles from "../styles/TeamComparison.styles";
import TeamLogo from "../../team/components/TeamLogo";

const Section = ({ label, data, expanded }) => {
	const boxScoreClasses = boxScoreStyles();
	const classes = teamComparisonStyles();

	const [open, setOpen] = useState(expanded);

	return (
		<>
			<TableContainer>
				<Table className={boxScoreClasses.tablePrintFriendly}>
					<TableHead className={boxScoreClasses.header}>
						<TableRow onClick={() => setOpen(!open)}>
							<TableCell className={classes.column}>
								<IconButton
									aria-label="expand row"
									size="small"
									className={boxScoreClasses.nonPrintable}
								>
									{open ? <ExpandLess /> : <ExpandMore />}
								</IconButton>
							</TableCell>
							<TableCell align="center" className={classes.column}>
								<Typography className={classes.sectionSubtitle}>{label}</Typography>
							</TableCell>
							<TableCell align="center" className={classes.column} />
						</TableRow>
					</TableHead>
					<TableBody />
				</Table>
			</TableContainer>
			<Collapse in={open} timeout="auto" unmountOnExit>
				<TableContainer>
					<Table className={boxScoreClasses.tablePrintFriendly}>
						<TableBody>
							{data &&
								data
									.filter((d) => !d.hidden)
									.map(({ away, name, home }) => (
										<TableRow className={boxScoreClasses.row} key={name}>
											<TableCell align="center" className={classes.column}>
												{away}
											</TableCell>
											<TableCell align="center" className={classes.column}>
												{name}
											</TableCell>
											<TableCell align="center" className={classes.column}>
												{home}
											</TableCell>
										</TableRow>
									))}
						</TableBody>
					</Table>
				</TableContainer>
			</Collapse>
		</>
	);
};

const TeamComparison = ({ boxScore = {}, expanded = false }) => {
	const classes = teamComparisonStyles();
	const boxScoreClasses = boxScoreStyles();
	const { statistics, awayTeam, homeTeam } = boxScore;

	return (
		<Paper variant="outlined">
			<TableContainer>
				<Table className={boxScoreClasses.tablePrintFriendly}>
					<TableHead className={boxScoreClasses.header}>
						<TableRow>
							<TableCell align="center" className={classes.column}>
								<TeamLogo team={awayTeam} hideName teamNameAsDefault />
							</TableCell>
							<TableCell align="center" className={classes.column}>
								<Typography className={boxScoreClasses.textBold}>
									Statistical Summary
								</Typography>
							</TableCell>
							<TableCell align="center" className={classes.column}>
								<TeamLogo team={homeTeam} hideName teamNameAsDefault />
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody />
				</Table>
			</TableContainer>
			{statistics &&
				statistics.map((item) => (
					<Section key={item.label} {...item} expanded={expanded} />
				))}
		</Paper>
	);
};

export default TeamComparison;
